import Console from '@/shared/console';
// import googleAnalytics from '../../node_modules/jll-google-analytics/src/lib-components/jllGoogleAnalytics.js';
import pendoUtils from '@/shared/pendoUtils.js';
import VueAppInsights from 'vue-application-insights';
import commonInterceptors from '@/interceptors/commonInterceptors.interceptor.js';
import pixAxios from '@/axios/pixAxios.js';
import pixAxiosSyncRequests from '@/axios/pixAxiosSyncRequests.js';

const initGoogleMapsKey = (_store) => {
  pixAxios
    .get('api/KeyVault/GetGoogleMapsApiKey')
    .then((response) => {
      if (response?.data?.googleMapsApiKey) {
        _store.dispatch('keysModule/setGoogleMapsApiKey', response.data.googleMapsApiKey);
      } else {
        Console.error('Could not retrieve Google Maps Api key from keyvault');
      }
    })
    .catch(() => {
      Console.error('Could not retrieve Google Maps Api key from keyvault');
    });
};

const initDeployEnvironment = (_store, username, instance) => {
  pixAxios
    .get('api/KeyVault/GetDeployEnvironment')
    .then((response) => {
      const environment = window.location.host.includes('localhost') ? 'LOCAL' : response?.data?.deployEnvironment;
      if (environment) {
        if (environment !== 'PRO') {
          document.title = `PIX | ${environment}`;
        }
        _store.dispatch('keysModule/setDeployEnvironmentKey', environment);
        Console.showLogs = environment === 'DEV' || environment === 'QA' || environment === 'LOCAL';
      } else {
        Console.error('Could not retrieve Deploy environment from keyvault');
      }
    })
    .catch(() => {
      Console.error('Could not retrieve Deploy environment from keyvault');
    });
};

const initPendo = (user, instance) => {
  pixAxios
    .get('api/KeyVault/GetPendoApiKey')
    .then((response) => {
      const pendoApiKey = response?.data?.pendoApiKey;
      if (pendoApiKey) {
        pendoUtils.load(pendoApiKey);
        pendoUtils.initialize(user, instance);
      } else {
        Console.error('Could not retrieve Pendo apikey from keyvault');
      }
    })
    .catch(() => {
      Console.error('Could not retrieve Pendo apikey from keyvault');
    });
};

const initChromaticUrl = (_store) => {
  pixAxios
    .get('api/KeyVault/GetChromaticUrl')
    .then((response) => {
      _store.dispatch('keysModule/setChromaticUrl', response?.data?.chromaticUrl);
    })
    .catch(() => {
      Console.error('Could not retrieve chromatic url from keyvault');
    });
};

const initErrorInterceptors = (langCode, _store) => {
  const languageError = {
    en: 'Network Error',
    es: 'Error del servidor',
  };
  const translate = languageError[langCode] || languageError.en;
  commonInterceptors.setErrorInterceptors(pixAxios, _store, translate);
  commonInterceptors.setErrorInterceptors(pixAxiosSyncRequests, _store, translate);
};

const initAppInsights = (router, Vue) => {
  pixAxios
    .get('api/KeyVault/GetAppInsightsInstrumentationKey')
    .then((response) => {
      Vue.use(VueAppInsights, {
        id: response?.data?.instrumentationKey,
        router,
      });
    })
    .catch(() => {
      Console.error('Could not retrieve App insights url from keyvault');
    });
};

export { initGoogleMapsKey, initDeployEnvironment, initPendo, initChromaticUrl, initErrorInterceptors, initAppInsights };
